/**
 * Returns the backend root URL (e.g. https://feip.app/backend) at runtime
 * based on window.location.host, so one build works for prod and dev.
 * Company portal: portal.dev.feip.app (dev), portal.feip.app (prod).
 */
function getApiBaseUrl() {
  if (typeof window === 'undefined') {
    const env = process.env.REACT_APP_API_URL || 'https://feip.app/backend/api/v1';
    return env.replace(/\/api\/v1\/?$/, '');
  }

  const host = window.location.host;
  const protocol = window.location.protocol;

  let url;
  if (host === 'portal.dev.feip.app') {
    url = `${protocol}//dev.feip.app/backend`;
  } else if (host === 'portal.feip.app') {
    url = `${protocol}//feip.app/backend`;
  } else if (host.includes('localhost') || host.includes('127.0.0.1')) {
    if (process.env.REACT_APP_API_URL) {
      url = process.env.REACT_APP_API_URL.replace(/\/api\/v1\/?$/, '');
    } else {
      url = 'http://127.0.0.1:8000/backend';
    }
  } else {
    url = `${protocol}//feip.app/backend`;
  }

  if (process.env.NODE_ENV === 'development') {
    console.log('[Company Portal] API base URL:', url);
  }
  return url;
}

export default getApiBaseUrl;
